import { IsIn, IsInt, IsObject, IsOptional, IsString, Max, Min } from "class-validator";
import { Type } from "class-transformer";
import {
    CreateGameInDTO as BaseCreateGameInDTO,
    StartGameInDTO as BaseStartGameInDTO,
    ProcessActionInDTO as BaseProcessActionInDTO,
    ProcessActionOutDTO as BaseProcessActionOutDTO,
    GameSessionChallengeDTO as BaseGameSessionChallengeDTO,
    GetNextChallengeOutDTO as BaseGetNextChallengeOutDTO,
    GetNextChallengeInDTO as BaseGetNextChallengeInDTO,
    GameSessionResultDTO as BaseGameSessionResultDTO,
    GameSessionChallengeResultDTO as BaseGameSessionChallengeResultDTO
} from "../../types"

export const CreateGameModeValues = [
    'first', 'last', 'first_and_last'
] as const;

export type CreateGameInMode = typeof CreateGameModeValues[number];

export class CreateGameInCharacterDTO {
    @IsString()
    symbol: string;

    /**
     * Опционально, можно будет прослушать произношение
     */
    @IsOptional()
    @IsString()
    pinyin?: string;

    /**
     * Перевод иероглифа
     */
    @IsOptional()
    @IsString()
    definition?: string;
}

export class CreateGameConfigDTO extends BaseCreateGameInDTO {
    /**
     * Режим игры. Выбрать первую, последнюю или и первую и последнюю черты
     */
    @IsIn(CreateGameModeValues)
    @IsString()
    mode: CreateGameInMode;

    /**
     * Количество иероглифов. Работает только в случае, если нужен рандом
     */
    @IsOptional()
    @IsInt()
    @Max(20)
    count?: number;

    @IsOptional()
    @IsInt()
    @Min(2)
    minStrokes?: number;

    @IsOptional()
    @IsInt()
    @Min(64)
    maxStrokes?: number;

    /**
     * Если не указано, то будет рандомиться
     */
    @IsOptional()
    @Type(() => CreateGameInCharacterDTO)
    characters?: CreateGameInCharacterDTO[];
}

export class CreateGameInDTO extends BaseCreateGameInDTO {
    config: CreateGameConfigDTO
}

export type ProcessActionType = 'first_stroke' | 'last_stroke';

export class StartGameInDTO extends BaseStartGameInDTO {}
export class ProcessActionInDTO extends BaseProcessActionInDTO {
    @IsObject()
    action: {
        type: ProcessActionType,
        data: {
            index: number,
            // strokeType: 'first' | 'last',
            challengeId: string
        }
    };
}

export class GameSessionChallengeStateDTO {
    strokes: {
        [s in 'first' | 'last']?: {
            errors: number,
            completed: boolean,
            success: number[],
            failed: number[]
        }
    }
}

export class GameSessionChallengeDTO extends BaseGameSessionChallengeDTO {
    symbol: string;
    strokes: string[];
    state: GameSessionChallengeStateDTO = { strokes: {} }
}

export class ProcessActionOutDTO extends BaseProcessActionOutDTO {
    nextChallenge?: GameSessionChallengeDTO;
    state: GameSessionChallengeStateDTO = { strokes: {} };
}


export class NextChallengeOutDTO extends BaseGetNextChallengeOutDTO {
    nextChallenge?: GameSessionChallengeDTO;
    state: GameSessionChallengeStateDTO = { strokes: {} };
}

export class NextChallengeInDTO extends BaseGetNextChallengeInDTO {
    nextChallenge?: GameSessionChallengeDTO;
}

export class GameSessionChallengeResultDTO extends BaseGameSessionChallengeResultDTO {
    data: {
        symbol: string;
        graphical: {
            strokes: string[],
            medians: [number, number][][],
        }
    }
}

export class GameSessionResultDTO extends BaseGameSessionResultDTO {
    challenges: GameSessionChallengeResultDTO[];
}
